import _ from 'lodash'

import {
  GET_LIST,
  GET_ONE,
  CREATE,
  UPDATE,
  DELETE,
  GET_MANY,
  GET_MANY_REFERENCE
} from './restTypes'

import {
  jsonApiHttpClient,
  queryParameters,
  handleFilters,
  handleSort
} from './fetch'

export default (apiUrl, httpClient = jsonApiHttpClient) => {
  /**
   * @param {String} type One of the constants appearing at the top if this file, e.g. 'UPDATE'
   * @param {String} resource Name of the resource to fetch, e.g. 'posts'
   * @param {Object} params The REST request params, depending on the type
   * @returns {Object} { url, options } The HTTP request parameters
   */
  const convertRESTRequestToHTTP = (type, resource, params) => {
    let url = ''
    let query

    const options = {
      // eslint-disable-next-line
      headers: new Headers({'Authorization': localStorage.getItem('token')})
    }

    switch (type) {
      case GET_MANY_REFERENCE:
      case GET_LIST:
        const {page, perPage} = params.pagination

        const sort = handleSort(params.sort)
        const filters = handleFilters(params.filter)

        query = {
          ...filters,
          $sort: sort,
          'isDeleted': false,
          $skip: (page - 1) * perPage,
          $limit: perPage,
          $page: page
        }

        url = `${apiUrl}/${resource}?${queryParameters(query)}`
        break
      case GET_ONE:
        url = `${apiUrl}/${resource}/${params.id}`
        break
      case GET_MANY:
        query = {'_id': JSON.stringify(params.ids)}
        url = `${apiUrl}/${resource}?${queryParameters(query)}`
        break
      case UPDATE:
        url = `${apiUrl}/${resource}/${params.id}`
        options.method = 'PUT'
        delete params.data.id
        delete params.data.createdAt
        delete params.data.updatedAt
        delete params.data.deletedAt
        delete params.data.isDeleted
        delete params.data.isActive
        delete params.data.totalBalance

        if (resource === 'user') {
          if (params.data._organizationList && !_.isArray(params.data._organizationList)) {
            params.data._organizationList = [ params.data._organizationList ]
          }

          if (params.data._gasStationList && !_.isArray(params.data._gasStationList)) {
            params.data._gasStationList = [ params.data._gasStationList ]
          }
        }

        options.body = JSON.stringify(params.data)
        break
      case CREATE:
        url = `${apiUrl}/${resource}`
        options.method = 'POST'

        if (resource === 'user') {
          if (params.data._organizationList && !_.isArray(params.data._organizationList)) {
            params.data._organizationList = [ params.data._organizationList ]
          }

          if (params.data._gasStationList && !_.isArray(params.data._gasStationList)) {
            params.data._gasStationList = [ params.data._gasStationList ]
          }
        }

        options.body = JSON.stringify(params.data)
        break
      case DELETE:
        url = `${apiUrl}/${resource}/${params.id}`
        options.method = 'DELETE'
        break
      default:
        throw new Error(`Unsupported fetch action type ${type}`)
    }

    return {url, options}
  }

  const convertHTTPResponseToREST = (response, type, resource, params) => {
    const { json } = response

    switch (type) {
      case GET_LIST:
      case GET_MANY_REFERENCE:
      case GET_MANY:
        if (!json.items || json.items.total === undefined) {
          throw new Error('Return the total of documents in the response items!')
        }

        const newData = json.docs.map((doc) => {
          return {
            ...doc,
            id: doc._id
          }
        })

        return {
          data: newData,
          total: json.items.total
        }
      case CREATE:
        const newJson = {
          ...json,
          id: json._id
        }

        return { data: { ...params.data, ...newJson } }
      case UPDATE:
      case GET_ONE:
        const jsonWithID = {
          ...json,
          id: json._id
        }

        return { data: { ...jsonWithID } }
      case DELETE:
        return { data: 'deleted' }
      default:
        return { data: json }
    }
  }

  /**
   * @param {string} type Request type, e.g GET_LIST
   * @param {string} resource Resource name, e.g. "posts"
   * @param {Object} payload Request parameters. Depends on the request type
   * @returns {Promise} the Promise for a REST response
   */
  return (type, resource, params) => {
    const { url, options } = convertRESTRequestToHTTP(type, resource, params)

    return httpClient(url, options)
      .then(response => convertHTTPResponseToREST(response, type, resource, params))
  }
}



// WEBPACK FOOTER //
// ./src/services/restClient.js